import { Quaternion } from './quaternion.js';
import { Vector3 } from '../util/vector-utils.js';
import { Axis, CORONAL, SAGITTAL, TRANSVERSE, } from '../types';
import { roundFloat } from '../util/math-util';
function sagitalSignCorrection(val, childSegment) {
    var swapSign = childSegment.includes('upper-leg') || childSegment.includes('arm');
    if (swapSign) {
        return -val;
    }
    return val;
}
function coronalSignCorrection(val, childSegment) {
    var isLeft = childSegment.includes('left');
    if (isLeft) {
        return -val;
    }
    return val;
}
function transversSignCorrection(val, childSegment) {
    var isLeft = childSegment.includes('left');
    if (isLeft) {
        return -val;
    }
    return val;
}
var Joint = (function () {
    function Joint(child) {
        this.orientation = Quaternion.ONE;
        this.position = new Vector3();
        this.child = child;
        this.basisVectors = {
            parent: [],
            child: [],
        };
    }
    Joint.prototype.update = function (position, qModel) {
        this.orientation = qModel;
        this.position = position;
        this.child.update(position);
        this.basisVectors.parent = this.orientation.toBasisVectors().map(function (v) { return new Vector3(v); });
        this.basisVectors.child = this.child.qModel.toBasisVectors().map(function (v) { return new Vector3(v); });
    };
    Joint.prototype.getAnatomicalAngles = function () {
        var q = this.orientation.conjugate().mul(this.child.qModel);
        var angles = q.toEuler('yxz');
        angles[SAGITTAL] = sagitalSignCorrection(angles[SAGITTAL], this.child.name);
        angles[CORONAL] = coronalSignCorrection(angles[CORONAL], this.child.name);
        angles[TRANSVERSE] = transversSignCorrection(angles[TRANSVERSE], this.child.name);
        return angles.map(Math.round);
    };
    Joint.prototype.getMomentSagittal = function (moment) {
        var normalAxis = Axis.Y;
        var normal = this.basisVectors.parent[normalAxis];
        var momentSagital = sagitalSignCorrection(moment.dot(normal), this.child.name);
        return roundFloat(momentSagital, 3);
    };
    Joint.prototype.getMomentCoronal = function (moment) {
        var normalAxis = Axis.X;
        var normal = this.basisVectors.parent[normalAxis];
        return roundFloat(moment.dot(normal), 3);
    };
    Joint.prototype.getMomentTransverse = function (moment) {
        var normalAxis = Axis.Z;
        var normal = this.basisVectors.parent[normalAxis];
        return roundFloat(moment.dot(normal), 3);
    };
    Joint.prototype.getAnatomicalMoments = function (moment) {
        return [
            this.getMomentSagittal(moment),
            this.getMomentCoronal(moment),
            this.getMomentTransverse(moment),
        ];
    };
    return Joint;
}());
export { Joint };
//# sourceMappingURL=joint.js.map